import axios from '../http'
import {API} from "../const"

const api = API+'/categories/categories';

const brandsApi = API+'/brands';

const categorys = API+'/categories/goods'

const error = (name) => (e) => console.error(name + ':=>', e);

export function listCategory(cb, fcb = error('listCategory')) {
  axios.get(api).then(d => cb(d.data)).catch(d => fcb(d))
}

export function listBrands(cid, cb, fcb = error('listBrands')) {
  axios.get(`${categorys}?categoryId=${cid}`).then(d => cb(d.data)).catch(d => fcb(d))
}